import React from 'react';
import { Footer } from './Footer';

interface LayoutProps {
  children: React.ReactNode;
  currentView?: 'home' | 'optimization' | 'visualization';
  onNavigate?: (view: 'home' | 'optimization' | 'visualization') => void;
}

export const Layout: React.FC<LayoutProps> = ({ 
  children, 
  currentView, 
  onNavigate
}) => {
  return (
    <div className="min-h-screen bg-gray-50 flex flex-col">
      
      <main className="flex-1">
        {currentView === 'home' ? (
          children
        ) : (
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
            {children}
          </div>
        )}
      </main>
      
      <Footer />
    </div>
  );
}; 